import { DesignContextProvider } from "Components/DesignContext";
import React from "react";
import { render } from "react-dom";
import SocialBanner from "./SocialBanner";
import { PageBase } from "Pages/PageBase";

export function initSocialBanner(accountId: Guid, venueId: Guid, elementId) {
   const container = document.getElementById(elementId);

   if (!container) {
      return;
   }

   render(
      <PageBase>
         <DesignContextProvider name="primary">
            <SocialBanner accountId={accountId} venueId={venueId} />
         </DesignContextProvider>
      </PageBase>
      , container);
}